module.exports = __webpack_public_path__ + "static/media/mobile.46807fe6.png";